module.exports = __webpack_public_path__ + "static/img/wechat_msg.251687b4.png";